export type DefineIsButtonDisabledProps = {
    userAcceptingTerms: boolean,
    setupMFA: boolean,
    mfaVerify: boolean,
    verifyCode: string,
    resetCode?: string,
    errorMessage: string,
    pwValidationMsg: string,
    newPass: string,
    currentPass: string,
    oldPass: string,
    getUserName: boolean,
    expiredResetPass: boolean,
    forceResetPass: boolean,
    userNameValue: string,
    userResetPass: boolean,
    loading?: boolean,
    onlyNumbersForVerification?: boolean
}

type DefineIsButtonDisabledType = (
    props: DefineIsButtonDisabledProps
) => boolean;

export const defineIsButtonDisabled: DefineIsButtonDisabledType = (props) => {
    const { userAcceptingTerms,
        setupMFA,
        mfaVerify,
        verifyCode,
        resetCode,
        errorMessage,
        pwValidationMsg,
        newPass,
        currentPass,
        oldPass,
        getUserName,
        expiredResetPass,
        forceResetPass,
        userNameValue,
        userResetPass,
        loading,
        onlyNumbersForVerification } = props;
    if (userAcceptingTerms) {
        return false
    }
    if (setupMFA || mfaVerify) {
        return loading ? true : verifyCode ? false : true;
    }
    if (userResetPass) {
        return loading ? true : (resetCode && onlyNumbersForVerification && !pwValidationMsg && newPass && currentPass) ? false : true;
    }
    if (forceResetPass) {
        return loading ? true : (!errorMessage && !pwValidationMsg && currentPass && newPass) ? false : true;
    }
    if (expiredResetPass) {
        return loading ? true : (!errorMessage && !pwValidationMsg && currentPass && newPass && oldPass) ? false : true;
    }
    if (getUserName) {
        return loading ? true : userNameValue ? false : true
    }
    return true;
};